var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-page',{attrs:{"id":_vm.app_id,"image_source":_vm.image_source,"image_height":_vm.image_height,"main_filters":_vm.main_filters}},[_c(_vm.app_name,{ref:_vm.app_name,tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }